/**
 * About Page — sections & items
 * Future: fetched from Supabase
 */

const aboutPage = {
  seo: {
    title: "À propos",
    description:
      "Sublime Résine, jeune entreprise québécoise spécialisée dans la création de bijoux artisanaux en résine UV — uniques, délicats, éclatants et entièrement personnalisables.",
    path: "/a-propos",
  },
  sections: [
    {
      id: "about_hero",
      type: "hero_split",
      isActive: true,
      sortOrder: 1,
      data: {
        badge: { icon: "sparkles", text: "Notre histoire" },
        title: "Bienvenue chez",
        titleAccent: "Sublime Résine",
        paragraphs: [
          "Une jeune entreprise québécoise dédiée à la création de bijoux uniques, délicats et éclatants.",
          "Chaque pièce est soigneusement fabriquée à la main à partir de résine UV, un matériau d'exception qui permet de révéler toute la délicatesse des détails.",
        ],
        image:
          "https://images.pexels.com/photos/6262831/pexels-photo-6262831.jpeg?auto=compress&cs=tinysrgb&w=1200",
        imageAlt: "Atelier artisanal Sublime Résine au Québec",
      },
    },
    {
      id: "about_mission",
      type: "text_block",
      isActive: true,
      sortOrder: 2,
      data: {
        title: "Une histoire qui vous ressemble",
        text: "Sublime Résine, c'est l'art de transformer de petites étincelles d'imagination en bijoux qui racontent une histoire — la vôtre.",
      },
    },
    {
      id: "about_values",
      type: "card_grid",
      isActive: true,
      sortOrder: 3,
      data: {
        title: "Ce qui rend chaque bijou unique",
        subtitle: "Du choix des matériaux jusqu'aux plus petits éclats.",
      },
      items: [
        {
          id: "val_1",
          icon: "sparkles",
          title: "Résine UV",
          desc: "Un matériau d'exception qui révèle la délicatesse des détails et fixe la beauté pour longtemps.",
          isActive: true,
          sortOrder: 1,
        },
        {
          id: "val_2",
          icon: "heart",
          title: "Fait à la main",
          desc: "Chaque pièce est entièrement fabriquée à la main, avec soin et passion, dans mon atelier au Québec.",
          isActive: true,
          sortOrder: 2,
        },
        {
          id: "val_3",
          icon: "palette",
          title: "100 % personnalisable",
          desc: "Couleurs vibrantes, nuances douces, éclats scintillants, paillettes féeriques — chaque détail est choisi pour vous.",
          isActive: true,
          sortOrder: 3,
        },
        {
          id: "val_4",
          icon: "package",
          title: "Pour chaque occasion",
          desc: "Pour offrir, marquer un moment spécial ou simplement vous faire plaisir — une touche de magie au quotidien.",
          isActive: true,
          sortOrder: 4,
        },
      ],
    },
    {
      id: "about_craft",
      type: "split_image_right",
      isActive: true,
      sortOrder: 4,
      data: {
        title: "Une créativité sans limites",
        paragraphs: [
          "Chez Sublime Résine, la créativité n'a pas de limites. Je personnalise chaque bijou selon vos envies : couleurs vibrantes, nuances douces, éclats scintillants, paillettes féeriques… chaque élément est choisi pour créer un accessoire qui vous ressemble vraiment.",
          "Que ce soit pour offrir, pour marquer un moment spécial ou simplement pour vous faire plaisir, chaque création est pensée pour apporter une touche de magie à votre quotidien.",
        ],
        tags: [
          "Résine UV",
          "Fait à la main",
          "100 % personnalisable",
          "Couleurs sur mesure",
          "Paillettes féeriques",
        ],
        image:
          "https://images.pexels.com/photos/4354613/pexels-photo-4354613.jpeg?auto=compress&cs=tinysrgb&w=1200",
        imageAlt: "Personnalisation artisanale d'un bijou en résine UV",
      },
    },
    {
      id: "about_packaging",
      type: "split_image_left",
      isActive: true,
      sortOrder: 5,
      data: {
        title: "Un emballage soigné",
        paragraphs: [
          "Chaque bijou est délicatement emballé dans un écrin protecteur avant d'être expédié, pour que la réception de votre commande soit un moment aussi spécial que le bijou lui-même.",
          "Livraison partout au Canada par Poste Canada avec numéro de suivi inclus.",
        ],
        image:
          "https://images.unsplash.com/photo-1764764138654-9f29a11eed95?w=1200&q=80",
        imageAlt: "Emballage soigné Sublime Résine",
      },
    },
    {
      id: "about_cta",
      type: "cta_banner",
      isActive: true,
      sortOrder: 6,
      data: {
        title: "Prête à imaginer votre bijou ?",
        subtitle:
          "Découvrez les collections ou imaginons ensemble la pièce qui vous ressemble.",
        cta1: { label: "Voir les collections", href: "/bijoux" },
        cta2: { label: "Commander maintenant", href: "/commander" },
      },
    },
  ],
};

export default aboutPage;
